var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagUs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 20,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 0,
    width: 30,
    height: 1.538,
    fill: "#B31942"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 3.077,
    width: 30,
    height: 1.538,
    fill: "#B31942"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 6.154,
    width: 30,
    height: 1.538,
    fill: "#B31942"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 9.231,
    width: 30,
    height: 1.538,
    fill: "#B31942"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 12.308,
    width: 30,
    height: 1.538,
    fill: "#B31942"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    y: 15.385,
    width: 30,
    height: 1.538,
    fill: "#B31942"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    y: 18.462,
    width: 30,
    height: 1.538,
    fill: "#B31942"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 10.769,
    fill: "#0A3161"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1.08,
    r: 0.42,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 1.08,
    r: 0.42,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 1.08,
    r: 0.42,
    fill: "#fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3.23,
    r: 0.42,
    fill: "#fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 3.23,
    r: 0.42,
    fill: "#fff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 3.23,
    r: 0.42,
    fill: "#fff"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 5.38,
    r: 0.42,
    fill: "#fff"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5.38,
    r: 0.42,
    fill: "#fff"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 5.38,
    r: 0.42,
    fill: "#fff"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 7.54,
    r: 0.42,
    fill: "#fff"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7.54,
    r: 0.42,
    fill: "#fff"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 7.54,
    r: 0.42,
    fill: "#fff"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 9.69,
    r: 0.42,
    fill: "#fff"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 9.69,
    r: 0.42,
    fill: "#fff"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9.69,
    r: 0.42,
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagUs);
export default __webpack_public_path__ + "static/media/flag-us.f84e73d2f2c3e646e439a2dfafde15e2.svg";
export { ForwardRef as ReactComponent };